import { useTranslation } from 'react-i18next';
import {
  HiMagnifyingGlass,
  HiBanknotes,
  HiDocumentArrowUp,
  HiCalculator,
  HiLink,
  HiCalendarDays,
} from 'react-icons/hi2';
import {
  Section,
  Container,
  Header,
  Title,
  Subtitle,
  Grid,
  Card,
  IconWrapper,
  CardTitle,
  CardDescription,
} from './Features.styled';

const features = [
  {
    key: 'aiSearch',
    Icon: HiMagnifyingGlass,
    iconColor: '#1E3A8A',
    bgColor: '#DBEAFE',
  },
  {
    key: 'courtAccounts',
    Icon: HiBanknotes,
    iconColor: '#B45309',
    bgColor: '#FEF3C7',
  },
  {
    key: 'clientFiles',
    Icon: HiDocumentArrowUp,
    iconColor: '#059669',
    bgColor: '#D1FAE5',
  },
  {
    key: 'billing',
    Icon: HiCalculator,
    iconColor: '#4338CA',
    bgColor: '#E0E7FF',
  },
  {
    key: 'courtIntegration',
    Icon: HiLink,
    iconColor: '#DC2626',
    bgColor: '#FEE2E2',
  },
  {
    key: 'calendar',
    Icon: HiCalendarDays,
    iconColor: '#7C3AED',
    bgColor: '#F3E8FF',
  },
];

export default function Features() {
  const { t } = useTranslation();

  return (
    <Section id="funkcje">
      <Container>
        <Header>
          <Title>{t('features.title')}</Title>
          <Subtitle>{t('features.subtitle')}</Subtitle>
        </Header>
        <Grid>
          {features.map(({ key, Icon, iconColor, bgColor }) => (
            <Card key={key}>
              <IconWrapper $bgColor={bgColor}>
                <Icon size={24} color={iconColor} />
              </IconWrapper>
              <CardTitle>{t(`features.${key}.title`)}</CardTitle>
              <CardDescription>{t(`features.${key}.description`)}</CardDescription>
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}
